import React from "react";
import { Phone, Mail, MapPin, Plane, Facebook, Instagram, MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { DESTINATIONS, buildWhatsAppLink } from "../mock";
import { COMPANY } from "../data/terms";
import PoliciesModal from "./PoliciesModal";
import TermsModal from "./TermsModal";
import PrivacyModal from "./PrivacyModal";

const Footer = () => {
  const { t } = useLanguage();

  const col = (title, items) => (
    <div>
      <h4 className="font-display font-bold text-white mb-4">{title}</h4>
      <ul className="space-y-2.5">
        {items.map((it) => (
          <li key={it}>
            <a
              href="#buscador"
              className="text-white/70 hover:text-cyan-300 text-sm transition-colors"
            >
              {it}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer id="footer" className="bg-[#0d3b43] text-white">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex bg-white rounded-xl px-4 py-3 mb-4">
              <img
                src="/rsv-logo-trim.png"
                alt="RSV Transfers"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed">{t("tagline")}</p>
            <div className="flex gap-3 mt-5">
              <a href="#top" className="w-9 h-9 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#top" className="w-9 h-9 rounded-full bg-white/10 hover:bg-cyan-500 flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={buildWhatsAppLink(t("whatsappMsg"))}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("whatsappCta")}
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          {col(t("footerTransfers"), DESTINATIONS.map((d) => d.name))}

          <div>
            <h4 className="font-display font-bold text-white mb-4">{t("footerAbout")}</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#top" className="text-white/70 hover:text-cyan-300 text-sm transition-colors">
                  {t("aboutUs")}
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-white/70 hover:text-cyan-300 text-sm transition-colors">
                  {t("navContact")}
                </a>
              </li>
              <li>
                <PoliciesModal />
              </li>
              <li>
                <TermsModal />
              </li>
              <li>
                <PrivacyModal />
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4">{t("support")}</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 text-cyan-300" />
                <span>
                  {t("fromUsa")}
                  <br />
                  <span className="text-white font-semibold">+52 998 790 7699</span>
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-cyan-300" />
                <span>contact@rsvcancun.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-cyan-300" />
                <span>
                  {COMPANY.legalName}
                  <br />
                  {COMPANY.addressInline}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-center text-white/60 text-xs">
          © {new Date().getFullYear()} {COMPANY.legalName} – {COMPANY.tradeName}. {t("rights")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
